import { put, takeLatest } from "@redux-saga/core/effects";
import { setShowLoadingScreen } from "redux/slices/global";
import { Notification } from "components/Notification/Noti";

import {
  getListConfigAPI,
  createConfigAPI,
  updateConfigAPI,
  deleteConfigAPI,
  markDefaultConfigAPI,
  getSpecificUserStatusAPI,
} from "redux/api/agentStatusAPI";
import {
  setShowConfig,
  getListConfig,
  getListConfigResult,
  createConfig,
  updateConfig,
  deleteConfig,
  markDefaultConfig,
  getSpecificUserStatus,
  getSpecificUserStatusResult,
} from "redux/slices/agentStatus";
import objFieldsPermissionAPI from "services/objFieldsPermissionAPI";
import loadFormCreateService from "services/loadFormCreateAPI";

export default function* campaign() {
  yield takeLatest(getListConfig.type, GetListConfig);
  yield takeLatest(createConfig.type, CreateConfig);
  yield takeLatest(deleteConfig.type, DeleteConfig);
  yield takeLatest(updateConfig.type, UpdateConfig);
  yield takeLatest(markDefaultConfig.type, MarkDefaultConfig);
  yield takeLatest(getSpecificUserStatus.type, GetSpecificUserStatus);
}

function* GetListConfig(action) {
  try {
    yield put(setShowLoadingScreen(true));
    const response = yield getListConfigAPI(action.payload);
    yield put(getListConfigResult(response.data.data));
    yield put(setShowLoadingScreen(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* GetSpecificUserStatus() {
  try {
    const response = yield getSpecificUserStatusAPI();
    yield put(getSpecificUserStatusResult(response.data.data));
  } catch (error) {
    Notification("error", error.response.data.error);
  }
}

function* CreateConfig(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield createConfigAPI(action.payload);
    yield put(getListConfig());
    yield put(setShowLoadingScreen(false));
    Notification("success", "Create successfully!");
    yield put(setShowConfig(false));
    objFieldsPermissionAPI.clearCache();
    loadFormCreateService.clearCache();
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* DeleteConfig(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield deleteConfigAPI(action.payload);
    yield put(getListConfig());
    yield put(setShowLoadingScreen(false));
    Notification("success", "Delete successfully!");
    yield put(setShowConfig(false));
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* UpdateConfig(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield updateConfigAPI(action.payload);
    yield put(getListConfig());
    yield put(setShowLoadingScreen(false));
    Notification("success", "Update successfully!");
    yield put(setShowConfig(false));
    objFieldsPermissionAPI.clearCache();
    loadFormCreateService.clearCache();
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}

function* MarkDefaultConfig(action) {
  try {
    yield put(setShowLoadingScreen(true));
    yield markDefaultConfigAPI(action.payload);
    yield put(setShowLoadingScreen(false));
    yield put(getSpecificUserStatus());
    Notification("success", "Mark default successfully!");
  } catch (error) {
    yield put(setShowLoadingScreen(false));
    Notification("error", error.response.data.error);
  }
}
